import styled from 'styled-components';

export const RosterWrapper = styled.div`
  font-size: 15px;
  font-family: 'Lato';
`;

export const RosterPlayers = styled.div`
  overflow-y: scroll;
  max-height: 480px;
`;
